var A = /* @__PURE__ */ ((p) => (p.HPT = "hpt", p.LANDINGPAGE = "landingpage", p.SR = "sr", p))(A || {});
export {
  A as TrackEventOrigin
};
